/* global Quagga */

// Uses device camera to read barcodes

(function ($) {
    'use strict';

    const barcodeTypeOptions = {
        'Code 128': 'code_128_reader',    
        'Code 39': 'code_39_reader',     
        'Code 39 VIN': 'code_39_vin_reader', 
        'EAN': 'ean_reader',         
        'EAN-extended': 'ean_reader',
        'UPC': 'upc_reader',          
        'UPC-E': 'upc_e_reader',       
        'Codabar': 'codabar_reader',     
        'Interleaved 2 of 5': 'i2of5_reader',       
        'Standard 2 of 5': '2of5_reader',     
        'Code 93': 'code_93_reader'      
    };
    const defaultBarcodeType = 'Code 128';

    // these resolutionOptions should be added to this object in ascending order
    const resolutionOptions = {
        '320px': '320x240',
        '640px': '640x480',
        '800px': '800x600',
        '1280px': '1280x720',
        '1600px': '1600x960',
        '1920px': '1920x1080'
    };
    const defaultResolution = '1280px';

    // options to define how close barcodes are. Use x-small when far way and x-large when barcodes are very close
    const patchSizeOptions = [
        'x-small',
        'small',
        'medium',
        'large',
        'x-large'
    ];
    const defaultPatchSize = 'medium';

    // the number of CPU cores to use 
    const numberOfWorkerOptions = [
        0,
        1,
        2,
        4,
        8
    ];
    const defaultNumberOfWorkers = 4;

    const facingModeOptions = [
        'environment',
        'user'
    ];
    const defaultFacingMode = 'environment';

    $.widget("fd.control_scanner", {
        options: {
            // Quagga options
            type: defaultBarcodeType, // see `acceptedBarcodeTypes`
            resolution: defaultResolution, // see `acceptedResolutions`
            patchsize: defaultPatchSize, // see `acceptedPatchSizes`
            workers: defaultNumberOfWorkers, // see `acceptedNumberOfWorkers`
            torch: false, // the phone's "flashlight"
            halfsample: true, // this should be set to false when scanning very small barcodes and higher resolution scanning is needed
            facingmode: defaultFacingMode,
            frequency: 10, // number of scans per second
            // FD options
            startonload: false,
            numbertoscan: 0, // 0 = continuous scanning, greater than 0 indicates the number to scan until scanner closes (for instance, if your use-case is to scan a single barcode, supply `1` to this value)
            parentid: null,
            callback: function () { },
            samplingcount: 11, // sampling means to collect the last x results and return the result that occurred most frequently. This is a huge help to get consistent and valid scan results.
            samplingtimeout: 1000, // # milliseconds to restart the sampling process. 
            showinvalidboxes: false, // in the video, show a green rectangle around boxes that are not valid barcodes. This is usually just visual noise.
            videoiniterrorcss: "alert alert-danger text-center w-100 mb-0",
            videoiniterrormessage: "There was an error starting your camera. It may be that it is in use by another program."
        },

        // public properties and functions
        barcodeTypeOptions: barcodeTypeOptions,
        resolutionOptions: resolutionOptions,
        patchSizeOptions: patchSizeOptions,
        numberOfWorkerOptions: numberOfWorkerOptions,
        facingModeOptions: facingModeOptions,
        setOnProcessed: function (onProcessedCallback) {
            Quagga.offProcessed(this._onProcessed);
            this._onProcessed = onProcessedCallback;
            Quagga.onProcessed(this._onProcessed);
        },
        start: function () {
            if (!this._hasStopped) {
                Quagga.start();
                this.element.removeClass("d-none");
            } else {
                this._setEvents(this._activeCamera.deviceId);
            }
        },
        stop: function () {
            Quagga.stop();
            this.element.addClass("d-none");
            this._hasStopped = true;
        },
        toggleTorch: function (setTurnedOn) {
            if (this._hasTorch) {
                let track = Quagga.CameraAccess.getActiveTrack();
                track.applyConstraints({ advanced: [{ torch: setTurnedOn }] });
            }
        },
        setCamera: function (deviceId) {
            const self = this;

            if (self._availableCameras.length > 1) {
                if (deviceId) {
                    const cameraToFind = self._availableCameras.find(camera => camera.deviceId === deviceId);
                    if (cameraToFind) {
                        self._activeCamera = cameraToFind;
                    }
                } else {
                    const nextIndex = self._availableCameras.findIndex(camera => camera === self._activeCamera) + 1;
                    self._activeCamera = self._availableCameras[nextIndex === self._availableCameras.length ? 0 : nextIndex];
                }
                self.stop();
                self._setEvents(self._activeCamera.deviceId);            
            }
        },
        getCanvas: function () {
            return Quagga.canvas.dom.image;
        },

        // private fields and functions
        _hasStopped: false,
        _numberScanned: 0,
        _hasTorch: false,
        _availableCameras: [],
        _activeCamera: null,
        _quaggaState: {},
        _create: function () {
            const self = this;

            if (!self.options.parentid) {
                self.options.parentid = self.element.closest('[data-fd-parentid]').data('fd-parentid');
            }            
            
            self._setEvents(null);

            Quagga.onProcessed(self._onProcessed());
            Quagga.onDetected(self._onDetected());

            self.element.on("click.fdcontrol", function () {
                self.setCamera();
            });
        },
        _setEvents: function (deviceId) {
            const self = this;

            // validate options
            if (!(this.options.type in this.barcodeTypeOptions)) {
                console.error(this.options.type + " is not a valid barcode type option. Falling-back to " + defaultBarcodeType);
                this.options.type = defaultBarcodeType;
            }
            if (!(this.options.resolution in this.resolutionOptions)) {
                console.error(this.options.resolution + " is not a valid resolution option. Falling-back to " + defaultResolution);
                this.options.resolution = defaultResolution;
            }
            if (!this.patchSizeOptions.includes(this.options.patchsize)) {
                console.error(this.options.patchsize + " is not a valid patch size option. Falling-back to " + defaultPatchSize);
                this.options.patchSize = defaultPatchSize;
            }
            if (!this.numberOfWorkerOptions.includes(this.options.workers)) {
                console.error(this.options.workers + " is not a valid workers option. Falling-back to " + defaultNumberOfWorkers);
                this.options.workers = defaultNumberOfWorkers;
            }
            if (!this.facingModeOptions.includes(this.options.facingmode)) {
                console.error(this.options.facingmode + " is not a valid facing mode option. Falling-back to " + defaultFacingMode);
                this.options.facingmode = defaultFacingMode;
            }

            this._hasStopped = false;
            this._numberScanned = 0;

            const resolutionParts = this.resolutionOptions[this.options.resolution].split('x');
            this._quaggaState = {
                inputStream: {
                    target: this.element[0],
                    type: "LiveStream",
                    constraints: {
                        width: { min: parseInt(resolutionParts[0]) },
                        height: { min: parseInt(resolutionParts[1]) },
                        aspectRatio: { min: 1, max: 1 },
                        facingMode: deviceId ? undefined : this.options.facingmode,
                        deviceId: deviceId ? deviceId : undefined
                    }
                },
                locator: {
                    patchSize: this.options.patchsize,
                    halfSample: this.options.halfsample
                },
                numOfWorkers: this.options.workers,
                frequency: this.options.frequency,
                decoder: {
                    readers: [{
                        format: this.barcodeTypeOptions[this.options.type],
                        config: (this.barcodeTypeOptions !== 'EAN-extended' ? {} : {
                            supplements: [
                                'ean_5_reader', 'ean_2_reader'
                            ]
                        })
                    }]
                },
                locate: true
            };

            Quagga.init(this._quaggaState, function (err) {
                if (err) {
                    console.error(err);
                    if (err.name === "OverconstrainedError") {
                        // the widget was probably initialized with a resolution that is not supported by the device
                        // automatically try a lower resolution
                        const resolutions = Object.keys(resolutionOptions);
                        const index = resolutions.findIndex(resolution => resolution === self.options.resolution);
                        if (index > 0) {
                            self.options.resolution = resolutions[index - 1];
                            self._setEvents();
                            return;
                        }
                    }
                    if (self.options.videoiniterrormessage) {
                        self.element.replaceWith(`<div class='${self.options.videoiniterrorcss}'>${self.options.videoiniterrormessage}</div>`);
                    }
                    return;
                }
                self._initCameraSelection();
                self._checkCapabilities();

                if (self.options.startonload) {
                    self.start();
                    self.toggleTorch(self.options.torch);
                }
            });
        },
        _checkCapabilities: function () {
            let track = Quagga.CameraAccess.getActiveTrack();
            if (typeof track.getCapabilities === 'function') {
                const capabilities = track.getCapabilities();
                this._hasTorch = capabilities.torch;
            }
        },
        _initCameraSelection: function () {
            const self = this;
            let streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

            return Quagga.CameraAccess.enumerateVideoDevices()
                .then(function (devices) {
                    self._availableCameras = devices;
                    self._activeCamera = self._availableCameras.find(device => device.label === streamLabel) || devices.find(() => true);
                });
        },
        _reset: function () {
            this.stop();
            this._setEvents();
        },
        _onProcessed: function () {
            const self = this;

            return function (result) {
                const drawingCtx = Quagga.canvas.ctx.overlay,
                    drawingCanvas = Quagga.canvas.dom.overlay;

                if (result) {
                    if (result.boxes) {
                        drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                        if (self.options.showinvalidboxes) {
                            result.boxes.filter((box) => box !== result.box).forEach(function (box) {
                                Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: "green", lineWidth: 2 });
                            });
                        }
                    }

                    if (result.box) {
                        Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
                    }

                    if (result.codeResult && result.codeResult.code) {
                        Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
                    }
                }
            };
        },
        _onDetected: function () {
            const self = this;

            let samplings = [],
                lastResult,
                samplingTimeout,
                lastResultTimeout;

            return function (result) {
                let code = result.codeResult.code;

                // if some time has passed, clear the samplings to restart the sampling process
                clearTimeout(samplingTimeout);
                samplingTimeout = setTimeout(function() {
                    samplings = [];
                }, self.options.samplingtimeout);

                samplings.push(code);

                if (samplings.length >= self.options.samplingcount) {
                    // get the most frequent barcode
                    code = samplings.sort((a, b) => samplings.filter(v => v === a).length - samplings.filter(v => v === b).length).pop();
                    const samplingSet = [...new Set(samplings)];
                    samplings = [];

                    if (lastResult !== code) {
                        lastResult = code;

                        // clear the lastResult after some time has passed in case the user wants to rescan it for any reason
                        clearTimeout(lastResultTimeout);
                        lastResultTimeout = setTimeout(function() {
                            lastResult = null;
                        }, self.options.samplingtimeout * 5);

                        self.options.callback.call(self, {
                            parentid: self.options.parentid,
                            value: code,
                            numberScanned: ++self._numberScanned,
                            samplingSet // return the samplingSet in case the caller wants to analyze it further.
                        });

                        if (self.options.numbertoscan !== 0 && self.options.numbertoscan <= self.numberScanned) {
                            self.stop();
                        }
                    }
                }               
            };
        }
    });
}(jQuery));